import React from "react";
import { useTheme } from "@/components/ThemeProvider/ThemeProvider";
import ArrowWithTail from "@/assets/icons/ArrowWithTail";

function ArrowWithTailWrapper() {
  const { theme } = useTheme();

  const arrowColor = theme === "light" ? "#7A869A" : "#DFE1E6";

  return (
    <ArrowWithTail rotation={180} color={arrowColor} width="13" height="13" />
  );
}

export default ArrowWithTailWrapper;
